import axios from "axios";

export default {
    getDigitizationEmail: async (clientId) => {
        const { data } = await axios.get(`/clients/${clientId}/digitization_email/`)
        return data
    },
    postDigitize: async (clientId, attachmentIds, tempAttachmentNames) => {
        const { data } = await axios.post(`/clients/${clientId}/digitize/`, {
            attachment_ids: attachmentIds,
            temp_attachment_names: tempAttachmentNames
        })
        return data
    }
}